export default __webpack_public_path__ + "static/last-five-seconds-countdown-ddc186b41bdba012fab26bd9c7a7474c.mp3";